import React from 'react';
import 'antd/lib/layout/style/css';
import 'antd/lib/menu/style/css';
import 'antd/lib/avatar/style/css';
import 'antd/lib/dropdown/style/css';
import 'antd/lib/button/style/css';
import 'antd/lib/icon/style/css';
import 'antd/lib/drawer/style/css';
import './PrivateHeader.css';
import {connect} from "react-redux";
import PrivateHeaderMenu from "./PrivateHeaderMenu";
import {push} from 'connected-react-router';
import changeLanguage from "../../../../actions/changeLanguage";

class PrivateHeader extends React.Component {
  
  state = {
    visible: false
  };

  render() {
    return (
      <nav className="menuBar">
        <div className="rightMenu">
          <PrivateHeaderMenu includeUser={true} mode={'horizontal'} changeLanguage={this.props.changeLanguage}
                             language={this.props.language} logged={this.props.logged}
                             requiresCert={this.props.requiresCert} push={this.props.push}
                             pathname={this.props.pathname} userName={this.props.userName}/>
        </div>
      </nav>
    );
  }
}


function mapStateToProps(state) {
  return {
    pathname: state.router.location.pathname,
    logged: state.auth.logged,
    language: state.auth.language,
    userName: state.auth.userName,
  }
}

export default connect(mapStateToProps, {push, changeLanguage})(PrivateHeader);